import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import useSignIn from 'react-auth-kit/hooks/useSignIn'
import { AuthenticatedUserData } from '../../models/auth'
import { AppRoutes } from '../../helpers/routes'
import UserService from '../../services/UserService'
import { UserDTO } from '../../models/users'

const UserActivatedPage = () => {
    const navigate = useNavigate()
    const signIn = useSignIn()
    const { token } = useParams<{ token: string }>()

    useEffect(() => {
        if (!token) return
        new UserService().getUserUsingToken(token).then((response) => {
            if (response.status !== 200) return
            const user: UserDTO = response.data
            signIn({
                auth: { token, type: 'Bearer' },
                userState: {
                    picture: user.picture,
                    fullName: user.firstName + ' ' + user.lastName,
                } as AuthenticatedUserData,
            })
            navigate(AppRoutes.home)
        })
    }, [signIn, token, navigate])

    return (
        <div className="flex flex-col justify-center items-center w-full h-full gap-16">
            <CircularProgress size={128} />
        </div>
    )
}

export default UserActivatedPage
